import React from 'react';

// No react-icons used due to deployment issues
import './Footer.css';


const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-content">
      <span className="footer-title">dcdetails est. 2024</span>
      <div className="footer-socials">
        <a href="https://instagram.com/dcd3tails" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <svg
            width="2em"
            height="2em"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="17.5" cy="6.5" r="1.3" fill="currentColor" />
          </svg>
        </a>
        <a href="https://tiktok.com/@dcd3tails" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
          <svg
            width="2em"
            height="2em"
            viewBox="0 0 448 512"
            aria-hidden="true"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="footerTikTokGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#25F4EE" />
                <stop offset="55%" stopColor="#25F4EE" />
                <stop offset="100%" stopColor="#FE2C55" />
              </linearGradient>
            </defs>
            <path
              fill="url(#footerTikTokGradient)"
              d="M448 209.7a210.13 210.13 0 0 1-122.7-39.7v173.6c0 92.1-74.8 167-167 167S-8.7 435.7-8.7 343.6c0-92.1 74.9-167 167-167 9 0 17.7.7 26.2 2.1V120.3a211.94 211.94 0 0 0-25.9-1.6C39.2 118.7-56 213.9-56 332.9S39.2 547.1 158.3 547.1 372.6 452 372.6 333V87.2a214.68 214.68 0 0 0 117.8 35.4Z"
            />
          </svg>
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
